<template>
  <div class="cpex-ecosystem bg--color-02">
    <div class="container-wrapper bg--color-11">
      <div class="cpex-ecosystem__container container-new">
        <img
          :src="require('@/assets/img/token/ecosystem.svg')"
          alt="border"
          loading="lazy"
          class="cpex-ecosystem__img"
        >

        <div class="cpex-ecosystem__data">
          <div
            class="cpex-ecosystem__title txt txt--36px txt--44px--m txt--height-44px txt--height-58px--m txt--color-04 txt--bold"
            v-html="$t('token.ecosystemBlock.title')"
          />

          <div
            class="cpex-ecosystem__description txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03 mt-24"
            v-html="$t('token.ecosystemBlock.desc')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenEcosystem',
}
</script>

<style lang="scss" scoped>
.cpex-ecosystem {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: toRem(40px);
    }
  }

  &__data {
    display: flex;
    flex-direction: column;
  }

  &__img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    order: 1;

    @include bp(m) {
      order: unset;
    }

    @include bp(l) {
      max-width: 75%;
    }
  }
}
</style>
